export const changeTexture = function(item, newTex, slotName = 'face_texture.jpg') {
    for (let name in item.material.nodeTextures) {
        if (item.material.nodeTextures[name].name === slotName) {
            if (slotName === 'face_texture.jpg' || 'back_texture') {
                newTex.encoding = v3d.__faceTexture.encoding;
                newTex.wrapS = v3d.__faceTexture.wrapS;
                newTex.wrapT = v3d.__faceTexture.wrapT;
                newTex.anisotropy = v3d.__faceTexture.anisotropy;
            }
            // else if (slotName === 'back_texture') {
            //     newTex.encoding = v3d.__backText.encoding;
            //     newTex.wrapS = v3d.__backText.wrapS;
            //     newTex.wrapT = v3d.__backText.wrapT;
            //     newTex.anisotropy = v3d.__backText.anisotropy;
            // }
           // newTex.name = slotName

            item.material.nodeTextures[name] = newTex;
        }
    }
    item.material.needsUpdate = true;
};


export const changeTextureCustom = function(item, oldName, newTex) {
    for (let name in item.material.nodeTextures) {
        if (item.material.nodeTextures[name].name === oldName) {
            newTex.encoding = item.material.nodeTextures[name].encoding;
            newTex.wrapS = item.material.nodeTextures[name].wrapS;
            newTex.wrapT = item.material.nodeTextures[name].wrapT;
            newTex.anisotropy = item.material.nodeTextures[name].anisotropy;

            item.material.nodeTextures[name] = newTex;
        }
    }
    item.material.needsUpdate = true;
};